/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Branch_RequiredInputs */

const en_api_error_branch_required = /** @type {(inputs: Api_Error_Branch_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client has branches — select the branch for this case.`)
};

const pt_br2_api_error_branch_required = /** @type {(inputs: Api_Error_Branch_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este cliente possui filiais — selecione a filial deste caso.`)
};

/**
* | output |
* | --- |
* | "This client has branches — select the branch for this case." |
*
* @param {Api_Error_Branch_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_branch_required = /** @type {((inputs?: Api_Error_Branch_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Branch_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_branch_required(inputs)
	return pt_br2_api_error_branch_required(inputs)
});